import React from 'react';
import { Box } from '@mui/material';
import { UW_GLOBALS_CONTROLS_SX } from '../../views/underwriter/components/uwTileSpacing';

interface GlobalsRowProps {
  /** Product version and Carrier, on the left. */
  readonly leading: React.ReactNode;
  /** The globals, packed right. */
  readonly children: React.ReactNode;
}

/**
 * The underwriter globals row, single- and multi-rater alike. One label line
 * across the row, so every control's top edge meets.
 */
const GlobalsRow = ({ leading, children }: GlobalsRowProps) => (
  <Box
    display="flex"
    alignItems="flex-start"
    gap={2}
    sx={UW_GLOBALS_CONTROLS_SX}
  >
    <Box display="flex" alignItems="flex-start" gap="1rem" flexShrink={0}>
      {leading}
    </Box>
    <Box
      display="flex"
      justifyContent="flex-end"
      alignItems="flex-start"
      gap="1rem"
      flex={1}
      minWidth={0}
    >
      {children}
    </Box>
  </Box>
);

export default GlobalsRow;
